var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"className":"main page-inside page-not-found payment-result-page"}},[_c('div',{attrs:{"className":"main-wrapper"}},[_c('div',{attrs:{"className":"section hero-section"}},[_c('div',{attrs:{"className":"wrapper"}},[_c('div',{attrs:{"className":"title big"}},[_vm._v(_vm._s(_vm.$t('404')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }